// extracted by mini-css-extract-plugin
export default {"ldsDualRing":"Loading_ldsDualRing__z+PxC","lds-dual-ring":"Loading_lds-dual-ring__XM4mQ"};